module.exports = __webpack_public_path__ + "img/post-austria-cod-alternate.38f1d372.png";